import { useCallback } from "react";
import useSWR from "swr";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { Settings, UpdateLanguage, UpdateProfileRequestBody } from "./types";

export const useMeApi = () => {
  const api = useApi();

  const useSettings = useCallback(
    (signal: AbortSignal, email?: string) => {
      const url = email ? `/me/settings` : null;
      return useSWR<Settings | null, CustomError>(url, (url: string) => api.get<Settings>({ url, signal }));
    },
    [api],
  );

  // const getMe = useCallback(
  //   (signal: AbortSignal) => {
  //     const url = "/me/profile";
  //     return useSWRMutation<User | null, CustomError, string>(url, (url) => api.get<User>({ url, signal }));
  //   },
  //   [api]
  // );

  const updateMyProfie = useCallback(
    async (body: UpdateProfileRequestBody, mutateSettings: boolean) => {
      const url = `/me/profile`;
      await api.put<UpdateProfileRequestBody>(url, body);
      api.mutateCache([url, "/admin/mileages", "/admin/maintenances"]);
      mutateSettings && api.mutateCache(["/me/settings"]);
    },
    [api],
  );

  const updateMyLanguage = useCallback(
    async (updateLanguage: UpdateLanguage) => {
      const data = await api.put<UpdateLanguage>("/me/language", updateLanguage);
      api.mutateCache(["/me/language"]);
      api.mutateCache(["/me/settings"]);
      return data;
    },
    [api],
  );

  return {
    useSettings,
    // getMe,
    updateMyProfie,
    updateMyLanguage,
  };
};
